module.exports = __webpack_public_path__ + "static/media/spectrum_conway.913f70ea.jpg";